<div bsModal #staticModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-static"
     [config]="{backdrop: 'static'}" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 id="dialog-static" class="modal-title pull-left">
                    Export (Compare / Diff) Property {{ 'Components' | terminology | async }}
                </h4>
                <button type="button" class="close pull-right" (click)="staticModal.hide()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="medium-padding remove-margin">
                    <form [formGroup]="formGroup">
                        <p>This property contains both current & future fiscal years. Please select the fiscal year you would like to perform the compare/diff against.</p>

                        <div class="row top-buffer-20">
                            <div class="offset-md-1 col-md-9">
                                <div class="form-group">
                                    <label for="fiscalYear">Fiscal Year</label>
                                    <select class="sp-select form-control" formControlName="fiscalYear" placeholder="Select a Fiscal Year" id="fiscalYear">
                                        <option value="">-- Select a Fiscal Year --</option>
                                        <option *ngFor="let year of importRequest?.fiscalYears" [value]="year.year">{{year.year}} (Start Date {{year.fiscalYearStartMonth}}/1/{{year.year}})</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <footer class="text-start">
                <button type="button" class="btn btn-cancel" (click)="staticModal.hide()">Cancel</button>
                <button class="btn btn-success" (click)="onConfirm()">Submit</button>
            </footer>
        </div>
    </div>
</div>
